"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var UserProfileTemplate_1 = require("./UserProfileTemplate");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('Step4'), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'step4' },
    React.createElement(UserProfileTemplate_1.default, { customerUuid: props.customerUuid }))); });
